import { Contest } from '@freelancer/datastore/contests';

/**
 * Supported file types for preview. Used in contest details tab file contest
 * entry file previews.
 */
export const SUPPORTED_IMAGE_FORMATS: ReadonlyArray<string> = [
  'jpeg',
  'jpg',
  'png',
  'gif',
  'bmp',
];
export const SUPPORTED_VIDEO_FORMATS: ReadonlyArray<string> = [
  'mp4',
  'webm',
  'ogg',
];

export enum SupportedFileTypesForPreview {
  IMAGE = 'image',
  VIDEO = 'video',
}

export interface ContestFile {
  readonly id: number;
  readonly name: string;
  readonly url: string;
  readonly isDeleted?: boolean;
  readonly fileType?: SupportedFileTypesForPreview;
}

/**
 * Contest model used in contest view page.
 *
 * Projections: `entry_counts`, `file_details`, `job_details`, `upgrade_details`
 */
export interface ContestViewContest extends Contest {
  readonly usersInterested: number;
  readonly files?: ReadonlyArray<ContestFile>;
}
